export default __webpack_public_path__ + "static/media/option-triangle.4c94c5b0.svg";